import React from 'react';
import StatusSelect, { StatusSelectValueProps } from './StatusSelect';
import { SelectedBooleanStatusType } from './utils';

// TODO: сделать общими с подсказками в иконках
const ENABLED_MODE_STATUS = {
  true: 'Источник включен',
  false: 'Источник выключен',
  unknown: 'Состояние: Неизвестно',
};

export function EnableModeStatusSelect(props: StatusSelectValueProps<SelectedBooleanStatusType>) {
  return (
    <StatusSelect
      {...props}
      statusDescription={ENABLED_MODE_STATUS}
      allValuesLabel="Все состояния"
    />
  );
}
export default EnableModeStatusSelect;
